import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Route } from './shared/services/routing-helper.service';
import {planGuard} from "./shared/guards/plan.guard";
import {coverageGuard} from "./coverage/coverage.guard";
import { contractGuard } from './shared/guards/contract.guard';
import { subscriptionGuard } from './shared/guards/subscription.guard';
import { holderGuard } from './shared/guards/holder.guard';
import { notSellerModeGuard } from './shared/guards/not-seller-mode.guard';
import { DependentsModule } from './dependents/dependents.module';

export const routes: Routes = [
  {
    path: '',
    title: Route.Plans.title,
    redirectTo: Route.Plans.path,
    pathMatch: 'full'
  },
  {
    path: Route.Theme.path,
    title: Route.Theme.title,
    loadChildren: () => import('./theme/theme.module').then(module => module.ThemeModule),
  },
  {
    path: Route.Plans.path,
    title: Route.Plans.title,
    loadChildren: () => import('./plans/plans.module').then(module => module.PlansModule),
  },
  {
    path: Route.Coverage.path,
    title: Route.Coverage.title,
    loadChildren: () => import('./coverage/coverage.module').then(module => module.CoverageModule),
    canActivate: [
      planGuard,
      coverageGuard,
      contractGuard
    ]
  },
  {
    path: Route.Data.path,
    title: Route.Data.title,
    loadChildren: () => import('./data/data.module').then(module => module.DataModule),
    canActivate: [
      planGuard,
      contractGuard
    ]
  },
  {
    path: Route.Dependents.path,
    title: Route.Dependents.title,
    loadChildren: () => import('./dependents/dependents.module').then(module => module.DependentsModule),
    canActivate: [
      planGuard,
      contractGuard,
      holderGuard,
      // Sem `subscriptionGuard`, de propósito: a inscrição não existe mais
      // neste ponto da jornada — só nasce depois da assinatura do contrato
      // (ver `subscription.guard.ts`).
      //
      // Mesmo motivo do Contrato: quem cadastra o dependente é o titular, e
      // o modo vendedor só repassa um link de pagamento — não tem a sessão
      // de quem vai efetivamente preencher o formulário.
      notSellerModeGuard
    ]
  },
  {
    path: Route.Contract.path,
    title: Route.Contract.title,
    loadChildren: () => import('./contract/contract.module').then(module => module.ContractModule),
    canActivate: [
      planGuard,
      contractGuard,
      holderGuard,
      // Sem `subscriptionGuard`: é exatamente esta etapa que cria o
      // contrato sem inscrição nenhuma existir ainda.
      //
      // O modo vendedor nunca vê este documento: quem assina é o titular, na
      // tela de pagamento dele.
      notSellerModeGuard
    ]
  },
  {
    path: Route.Payment.path,
    title: Route.Payment.title,
    loadChildren: () => import('./payment/payment.module').then(module => module.PaymentModule),
    canActivate: [
      planGuard,
      contractGuard,
      // A inscrição já precisa existir: o pagamento agora vem depois do
      // contrato, e payments/create pressupõe uma inscrição criada.
      subscriptionGuard
    ]
  },
  {
    path: Route.Resume.path,
    title: Route.Resume.title,
    loadChildren: () => import('./resume/resume.module').then(module => module.ResumeModule),
    canActivate: [
      planGuard,
      contractGuard
    ]
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled',
    }),
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
